exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-editor__editable_inline {\n  height: 150px !important;\n  border: 1px #EBEBE4 solid !important;\n}\n.vue-select .vs__dropdown-option--highlight {\n  background: #16b394;\n  color: white;\n}\n.vue-select .vs__dropdown-option {\n  padding: 10px;\n}\n.vue-select .vs__dropdown-toggle {\n  border-radius: unset;\n  font-size: 11px;\n  height: 31px;\n}", ""]);

// exports
